import { Box, HStack, Text } from '@chakra-ui/layout';
import { Progress } from '@chakra-ui/react';
import * as React from 'react';

export const ProgressUploadCard: React.FC<{
  value?: number;
}> = ({ value }) => {
  if (value === 100) return null;

  return (
    <Box
      h={20}
      px="4"
      py="6"
      bg="gray.50"
      color="gray.600"
      borderRadius="base"
      border="1px"
      borderColor="gray.300"
    >
      <Text>Uploading...</Text>
      <HStack>
        <Progress
          value={value}
          size="sm"
          w="full"
          borderRadius="full"
          colorScheme="gray"
        />
        <Text>{Math.floor(value || 0)}%</Text>
      </HStack>
    </Box>
  );
};
